export function createArrayOfLength<T>(
  number: number,
  setDefaultValue?: (index: number) => T,
): (T | undefined)[] {
  return Array.from(Array(number).keys()).map(
    (index) => setDefaultValue?.(index) ?? undefined,
  );
}
